<template>
  <div class="vue-template">
    <div class="jumbotron bg-gradient">
      <div class="container">
        <h1 class="display-4">
          All Books
        </h1>
      </div>
    </div>
    <div class="container">
      <div class="input-group input-group-lg  books-search">
        <div class="input-group-prepend">
          <span class="input-group-text" id="inputGroup-sizing-lg">
            <b-icon icon="search"></b-icon>
          </span>
        </div>
        <input
          type="search"
          results="5"
          v-model="search"
          class="form-control"
          aria-label="Search for Books"
          placeholder="Search for ISBN oder Key Words"
          aria-describedby="inputGroup-sizing-lg"
        />
      </div>
      <div class="books-wrapper">
        <div
          class="list-item d-flex d-flex books-item"
          v-for="book in filteredList"
          :key="book.uid"
        >
          <router-link class="w-100" :to="'/book/' + book.id">
            <div class="books-item-image">
              <img :src="book.cover" :alt="'Cover for ' + book.title" />
            </div>
            <div class="books-item-typo">
              <span class="truncate-text"> {{ book.title }}</span>
              <span class="small" v-if="book.subtitle">
                - {{ book.subtitle | truncate(32) }}</span
              >
              <p class="author">von {{ book.author }}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import firebase from 'firebase';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      search: '',
    };
  },
  computed: mapState({
    filteredList() {
      return this.$store.state.books.filter(book => {
        return (
          (book.title &&
            book.title.toLowerCase().includes(this.search.toLowerCase())) ||
          (book.description &&
            book.description
              .toLowerCase()
              .includes(this.search.toLowerCase())) ||
          (book.subtitle &&
            book.subtitle.toLowerCase().includes(this.search.toLowerCase())) ||
          (book.isbn &&
            book.isbn.toLowerCase().includes(this.search.toLowerCase()))
        );
      });
    },

    books: state => state.books,
    currentUser: state => state.currentUser,
  }),
  created() {
    this.$store.dispatch('fetchBooks');
    this.$store.dispatch('fetchCurrentUser');
  },
};
</script>
